// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".has-border-bottom-grey-light[data-v-3ef7b09b]{border-bottom:1px solid #dbdbdb}.color-tertiary[data-v-3ef7b09b]{color:#2cd5c4}.color-primary[data-v-3ef7b09b]{color:#ef4a81}.color-grey-darker[data-v-3ef7b09b]{color:#363636}.color-grey[data-v-3ef7b09b]{color:#7a7a7a}.help.is-danger[data-v-3ef7b09b]{position:static}footer[data-v-3ef7b09b]{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
